(() => {
  if (customElements.get('iconic-collection-banner-second')) return;

  class IconicCollectionsHover extends HTMLElement {
    constructor() {
      super();
      this.sectionId = '';
      this.section = null;
      this.items = [];
      this.parent = null;
      this.scrollHandler = null;
      this.currentMode = null; 
    }
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.section = this.querySelector(`.iconic-collection-hover-section.iconic-section-${this.sectionId}`);
      if (!this.section) return;

      this.items = this.section.querySelectorAll('.iconic-category-title-with-image');
      if (!this.items.length) return;

      this.parent = this.section;

      if (!this.parent.dataset.originalStyle) {
        this.parent.dataset.originalStyle = this.parent.getAttribute('style') || '';
      }
      this.initMode();
      window.addEventListener('resize', () => this.initMode());
    }
    initMode() {
      const isMobile = window.innerWidth <= 768;

      if (isMobile && this.currentMode !== 'mobile') {
        this.cleanup();
        this.initMobile();
        this.currentMode = 'mobile';
      } else if (!isMobile && this.currentMode !== 'desktop') {
        this.cleanup();
        this.initDesktop();
        this.currentMode = 'desktop';
      }
    }
    initDesktop() {
      this.items.forEach((item) => {
        const blockId = item.dataset.blockId;
        const color = window.hoverColorMap?.[this.sectionId]?.[blockId] || '#f5f5f5';

        const enter = () => {
          this.items.forEach(i => i.classList.remove('active'));
          item.classList.add('active');
          this.parent.setAttribute('style', `background: ${color} !important;`);
        };

        const leave = () => {
          item.classList.remove('active');
          this.parent.setAttribute('style', this.parent.dataset.originalStyle || '');
        };
        item.addEventListener('mouseenter', enter);
        item.addEventListener('mouseleave', leave);
        item._hoverHandlers = { enter, leave };
      });
    }

    initMobile() {
      this.scrollHandler = () => {
        let closest = null;
        let minDistance = Infinity;
        const viewportCenter = window.innerHeight / 2;

        this.items.forEach((item) => {
          const rect = item.getBoundingClientRect();
          const itemCenter = rect.top + rect.height / 2;
          const distance = Math.abs(itemCenter - viewportCenter);

          if (distance < minDistance) {
            minDistance = distance;
            closest = item;
          }
        });
        if (closest) {
          const blockId = closest.dataset.blockId;
          const color = window.hoverColorMap?.[this.sectionId]?.[blockId] || '#f5f5f5';

          this.items.forEach(i => i.classList.remove('active'));
          closest.classList.add('active');
          this.parent.setAttribute('style', `background: ${color} !important;`);
        }
      };
      window.addEventListener('scroll', this.scrollHandler);
      window.addEventListener('load', this.scrollHandler);
      this.scrollHandler();
    }
    cleanup() {
      // Remove hover listeners
      this.items.forEach(item => {
        if (item._hoverHandlers) {
          item.removeEventListener('mouseenter', item._hoverHandlers.enter);
          item.removeEventListener('mouseleave', item._hoverHandlers.leave);
          delete item._hoverHandlers;
        }
      });

      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
        window.removeEventListener('load', this.scrollHandler);
        this.scrollHandler = null;
      }

      // Remove active classes
      this.items.forEach(i => i.classList.remove('active'));

      // Reset background
      if (this.parent) {
        this.parent.setAttribute('style', this.parent.dataset.originalStyle || '');
      }
    }
  }

  customElements.define('iconic-collection-banner-second', IconicCollectionsHover);
})();
